/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TipoAnimaleDTO } from './TipoAnimaleDTO';
import {
    TipoAnimaleDTOFromJSON,
    TipoAnimaleDTOFromJSONTyped,
    TipoAnimaleDTOToJSON,
} from './TipoAnimaleDTO';

/**
 * 
 * @export
 * @interface ListinoAnimaliDettaglioDTO
 */
export interface ListinoAnimaliDettaglioDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    idListino?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    valore?: number;
    /**
     * 
     * @type {TipoAnimaleDTO}
     * @memberof ListinoAnimaliDettaglioDTO
     */
    tipoAnimale?: TipoAnimaleDTO;
}

/**
 * Check if a given object implements the ListinoAnimaliDettaglioDTO interface.
 */
export function instanceOfListinoAnimaliDettaglioDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoAnimaliDettaglioDTOFromJSON(json: any): ListinoAnimaliDettaglioDTO {
    return ListinoAnimaliDettaglioDTOFromJSONTyped(json, false);
}

export function ListinoAnimaliDettaglioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoAnimaliDettaglioDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idListino': !exists(json, 'idListino') ? undefined : json['idListino'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
        'tipoAnimale': !exists(json, 'tipoAnimale') ? undefined : TipoAnimaleDTOFromJSON(json['tipoAnimale']),
    };
}

export function ListinoAnimaliDettaglioDTOToJSON(value?: ListinoAnimaliDettaglioDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idListino': value.idListino,
        'idTipoAnimale': value.idTipoAnimale,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
        'tipoAnimale': TipoAnimaleDTOToJSON(value.tipoAnimale),
    };
}

